"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var localTenant = process.env.CB_LOCAL_TENANT || 'dev';
var getSubDomain = function () {
    var parts = window.location.host.split('.');
    if (parts.length > 1)
        return parts[0];
    return process.env.NODE_ENV === 'development' ? localTenant : null;
};
var getTenantFromUrlParams = function () {
    var queryString = window.location.search;
    var urlParams = new URLSearchParams(queryString);
    return urlParams.get('tenant');
};
var getTenant = function () {
    var storedTenant = sessionStorage.getItem('tenant');
    var paramsTenant = getTenantFromUrlParams();
    if (paramsTenant && storedTenant !== paramsTenant) {
        sessionStorage.setItem('tenant', paramsTenant);
        storedTenant = paramsTenant;
    }
    if (storedTenant)
        return storedTenant;
    return getSubDomain();
};
exports.default = getTenant;
